'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withWindow = require('../helpers/withWindow');

var _withWindow2 = _interopRequireDefault(_withWindow);

var _NewNavigationBar = require('./NewNavigationBar');

var _NewNavigationBar2 = _interopRequireDefault(_NewNavigationBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withWindow2.default)(_NewNavigationBar2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewNavigationBar/index.js
// module id = 300
// module chunks = 0